/**
 * Thin wrapper around the shared ui-kit agent widget.
 *
 * The widget itself lives at `@isg/ui-kit` `renderAgentWidget`, so every ISG
 * app mounts the SAME implementation — SSE streaming, nav chips, two-phase
 * confirm, attachments. This file supplies purchasing's labels and
 * suggestions and delegates. Do not fork the widget; if it needs a new
 * capability, add it to ui-kit so the whole estate gains it.
 *
 * How-to for every purchasing user; operational + action tools for admins.
 *
 * ⚠️ It never surfaces a cost, a buy price, a supplier price or a margin —
 * for those it points you at the page. Purchasing content is restricted
 * commercial data (CLAUDE.md DO #5/#6): the backing model is LOCAL ONLY, and
 * it phrases numbers we computed rather than computing any itself.
 */
import { renderAgentWidget } from '@isg/ui-kit';

const SUGGESTIONS = [
  'What needs a purchase order this week?',
  'How do I raise a Hot Topic?',
  'Which lines are overdue?',
  'How is free stock different from available?',
  'Show me open issues assigned to me',
];

export function renderAIAssistant(container) {
  renderAgentWidget(container, {
    appSlug: 'purchasing',
    title: 'Purchasing Assistant',
    placeholder: 'Ask how to use the app, or what needs attention today…',
    suggestions: SUGGESTIONS,
    // 🔴 This assistant runs on the Claude API, and an attachment (a supplier
    // price list, an order book) is exactly the data that must stay local.
    // Questions about a value go through the ⓘ "Ask about this" tab instead,
    // which answers on ISG's own servers. (isg-figures, 2026-09-26)
    attachments: false,
  });
}
